<template>
    <div
        class="InputCheckbox"
        :class="{ 'is-checked' : checked }"
    >
        <figure>
            <input
                type="checkbox"
                :name="name"
                :checked="checked"
                @change="$emit('change', $event.target.checked)"
            >
        </figure>
        <label
            for="checkbox"
            v-html="termsMsg"
        />
    </div>
</template>
<script>
export default {
    name: 'InputCheckbox',
    model: {
        prop: 'checked',
        event: 'change'
    },
    props: {
        name: {
            type: String,
            required: true
        },
        termsMsg: {
            type: String,
            default: ''
        },
        checked: Boolean
    }
}
</script>
<style lang="scss" scoped>
    .InputCheckbox {
        display: flex;
        align-items: center;
        margin-bottom: getSpacing(base);
    }

    figure {
        position: relative;
        width: 25px;
        height: 25px;
        border: 2px solid getColor('sand');
        border-radius: 4px;
        cursor: pointer;
        transition: all ease-out 0.125s;

        .is-checked & {
            background: $action-color;
            border-color: $action-color;
        }

        &:after {
            display: flex;
            align-items: center;
            justify-content: center;
            content: "\2713";
            font-weight: bold;
            color: getColor('white');
        }
    }

    input {
        position: absolute;
        width: 100%;
        height: 100%;
        opacity: 0;
        cursor: pointer;
    }

    label {
        font-size: 0.75rem;
        padding-left: 1rem;
    }

    a {
        color: $action-color;
        font-weight: 700;
        border-bottom: 2px solid transparent;
        transition: all ease-out 0.3265s;

        &:hover {
            border-color: getColor('lightblue');
        }
    }
</style>
